import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => {
        const msg = error instanceof Error ? error.message : "";
        if (msg.includes("_401") || msg.includes("_403")) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
